const Profile = () => {
    return (
        <>
            HI
        </>
    );
};

export default Profile;
